import React, { Component } from 'react';
import cloneDeep from 'lodash/cloneDeep';
import classNames from 'classnames';
import { Link, withRouter } from 'react-router'
import { Field, FieldArray, reset } from 'redux-form'
import { SkyLightStateless } from 'react-skylight';
import { Translate, Localize } from 'react-redux-i18n';
import { Grid, Row, Col, Panel, ButtonToolbar, Button, DropdownButton, MenuItem, FieldGroup, Input, Breadcrumb } from 'react-bootstrap';
import Dropzone from 'react-dropzone';

import ContentWrapper from '../Layout/ContentWrapper';
import Selection from '../Common/selection'
import Spinner from '../Widgets/spinner';
import SpinnerButton from '../Common/SpinnerButton'
import { InputField, ControlledInputField } from '../Common/inputField';
import IsActive from '../Common/isActive';
import ConfirmActionModal from '../Common/confirmActionModal';
import MarketingModal from '../Products/components/MarketingModal';
import GroupsModal from './GroupsModal'
// Helping function to render a multi-fields form. Reference on redux-form array.
import {
  ROOT_URL, ROOT_API_URL, isSKH, isDAICHEONG, isOCM, isGGI, isSV, isOLG, isVAK,
  isTQ, isGFD, isAP,
} from '../../actions/root_url';
import { getImageUrl } from './apis';
import LevelView from './LevelView';

const titleOptions = [{
  label: 'Owner',
  value: 'Owner',
}, {
  label: 'Boss',
  value: 'Boss',
}, {
  label: 'Sales',
  value: 'Sales',
}, {
  label: 'Purchase',
  value: 'Purchase',
}, {
  label: 'Operation',
  value: 'Operation',
}, {
  label: 'Account',
  value: 'Account',
}, {
  label: 'Manager',
  value: 'Manager',
}, {
  label: 'Others',
  value: 'Others',
}];
let renderIsDefault = props => {
   // Bad implementation, cannot set the value attribute of Input componnet to a boolean.
   const titleClass = classNames({ 'parsley-error-label': props.meta.touched && props.meta.error }, 'control-label', 'col-sm-4')
   return (
     <div>
       <Row><Col sm={ 12 }>{props.meta.touched && props.meta.error && <span className="parsley-error-message">{props.meta.error}</span>}</Col></Row>
       <Row>
         <Col sm={ 5 }>
           <label className="default-address"><Translate value="default_address" /></label>
         </Col>
         <Col sm={ 2 }>
           <label>
              <Input {...props.input} type="radio" value={true} checked={props.input.value == true || props.input.value == "true" }/><Translate value="yes" />
           </label>
         </Col>
         <Col sm={ 2 }>
           <label>
               <Input {...props.input} type="radio" value={false} checked={props.input.value == false || props.input.value == "false" }/><Translate value="no" />
           </label>
         </Col>
       </Row>
     </div>
   )
 }

class renderShipping extends Component {
  constructor() {
    super();
    this.state = {
    }
  }

  copyBillingToShipping(e) {
    e.preventDefault();
    const shipping = cloneDeep(this.props.billing);
    shipping.VendorDetail_id = undefined;
    this.props.changeFieldArrayOfForm('Shipping', 0, shipping, 'vendorDetailForm');
  }

  renderDeleteButton(index, fields) {
    return (
      <Button
        bsStyle="danger"
        className="trash"
        type="reset"
        onClick={() => {
          fields.remove(index);
      } }>
        <em className="fa fa-trash-o"/>
      </Button>
    );
  }

  renderAutoFillButton() {
    return (
      <Button
        bsStyle="default"
        className="auto-fill"
        type="button"
        onClick={this.copyBillingToShipping.bind(this)}>
        <em className="fa fa-edit"/><Translate value="auto_fill" />
      </Button>
    );
  }

  renderAddress (Shipping, index) {
    return (
      <div>
        <Row className="form-horizontal">
          <div className="form-group">
            <label className="col-sm-2"><Translate value="name" /></label>
            <Col sm={ 10 }>
              <Field name={`${Shipping}.AddressName`} component={ InputField } />
            </Col>
          </div>
        </Row>
        <Row className="form-horizontal">
          <div className="form-group">
            <label className="col-sm-2"><Translate value="street" /><span className="asteriksReq">*</span></label>
            <Col sm={ 10 }>
              <Field name={`${Shipping}.Street`} component={ InputField } />
            </Col>
          </div>
        </Row>
        {isSV && 
          <Row className="form-horizontal">
            <div className="form-group">
              <label className="col-sm-2"><Translate value="street2" /></label>
              <Col sm={ 10 }>
                <Field name={`${Shipping}.Street1`} component={ InputField } />
              </Col>
            </div>
          </Row>
        }
        <Row>
          <Col sm={ isSV ? 3 : 6 }>
            <div className="form-group">
              <label><Translate value="city" /><span className="asteriksReq">*</span></label>
              <Field name={`${Shipping}.City`} component={ InputField } />
            </div>
          </Col>
          <Col sm={ 3 }>
            <div className="form-group">
              <label><Translate value="state" /><span className="asteriksReq">*</span></label>
              <Field name={`${Shipping}.State`} component={ InputField } />
            </div>
          </Col>
          <Col sm={ 3 }>
            <div className="form-group">
              <label><Translate value="zip" /><span className="asteriksReq">*</span></label>
              <Field name={`${Shipping}.Zip`} component={ InputField } />
            </div>
          </Col>
          {isSV &&
            <Col sm={ 3 }>
              <div className="form-group">
                <label><Translate value="country" /><span className="asteriksReq">*</span></label>
                <Field name={`${Shipping}.Country`} component={ InputField } />
              </div>
            </Col>
          }
        </Row>
        <Row>
          <Col sm={ 4 }>
            <div className="form-group">
              <label><Translate value="first_name" /></label>
              <Field name={`${Shipping}.FirstName`} component={ InputField } />
            </div>
          </Col>
          <Col sm={ 4 }>
            <div className="form-group">
              <label><Translate value="last_name" /></label>
              <Field name={`${Shipping}.LastName`} component={ InputField } />
            </div>
          </Col>
          <Col sm={ 4 }>
            <div className="form-group">
              <label><Translate value="tel" /></label>
              <Field name={`${Shipping}.Telephone`} component={ InputField } />
            </div>
          </Col>
        </Row>
        <Row>
          <Col sm={ 8 }>
            <div className="form-group">
              <label><Translate value="email" /></label>
              <Field name={`${Shipping}.Email`} component={ InputField } />
            </div>
          </Col>
          <Col sm={ 4 }>
            <div className="form-group">
              <label><Translate value="fax" /></label>
              <Field name={`${Shipping}.Fax`} component={ InputField } />
            </div>
          </Col>
          <Col sm={ 4 }>
            <div className="form-group">
              <label><Translate value="cel" /></label>
              <Field name={`${Shipping}.Cellphone`} component={ InputField } />
            </div>
          </Col>
        </Row>
      </div>
    );
  }

  render() {
    const fields = this.props.fields;
    return (
      <div>
        <Button
          bsStyle="primary"
          className="plus"
          type="button"
          onClick={() => {
            fields.push({})   // pushes empty child field onto the end of the array
        } }>
          <em className="fa fa-plus"/>
        </Button>
        {!fields.length && <div className="marginTopStyle" ><Translate value="no_shipping_information" /></div>}
        {fields.map((Shipping, index) =>
          <div>
            <Row key={index}>
              <Col sm={ 12 }>
                <div className="position-relative">
                  <h4><Translate value="shipping" /> #{index + 1}</h4>
                  {index === 0 && this.renderAutoFillButton()}
                  {this.renderDeleteButton(index, fields)}
                </div>
                {this.renderAddress(Shipping, index)}
                <Field name={`${Shipping}.IsDefault`} component={ renderIsDefault } />
              </Col>
            </Row>
          </div>
        )}
      </div>
    )
  }
}

class VendorDetailForm extends Component {
    static contextTypes = {
      router: React.PropTypes.object
    };

    constructor() {
      super();
      this.state = {
        dirty: false,
        companyOpen:false,
        checkedAll: false,
        currentCompanyId: -1,
        selectedCompanies: [],
        companies:[],
        case: "paymentTermMissing",
        groupsVisible: false,
        currentGroups: [],
      };
      this.openConfirm = this.openConfirm.bind(this);
      this.closeConfirm = this.closeConfirm.bind(this);
      this.openCompany = this.openCompany.bind(this);
      this.closeCompany = this.closeCompany.bind(this);
    }

    componentWillMount() {
      // reset('productForm');
    }

    componentDidMount() {
      const { currentVendor, selectedCompany, companies } = this.props;
      if (currentVendor) {
        this.props.fetchVendorDetail(currentVendor.Vendor_id)
          .then(() => this.props.fetchPaymentTerms());
      }
      else{
        this.props.fetchPaymentTerms();
        this.props.setDefaultOfForm('IsActive', false, 'vendorDetailForm');
        this.props.setDefaultOfForm('overseas', false, 'vendorDetailForm');
        if(isAP) {
          this.props.setDefaultOfForm('Level', '0', 'vendorDetailForm');
        }
      }
      // making a leaving hook to confirm leaving
      this.props.router.setRouteLeaveHook(this.props.route, this.routerWillLeave.bind(this));
      if(isGGI) {
        if(selectedCompany && selectedCompany.value && selectedCompany.value != this.state.currentCompanyId) {
          this.setState({currentCompanyId: selectedCompany.value})
        }
        if(companies && companies != null && companies.length >0 && companies != this.state.companies) {
          let companiesArr = [];
          companies.map(item => {
            if(item.id != 3) {
              companiesArr.push({id: item.id, Name: item.Name, checked: false, level: 0})
            }
          })
          this.setState({companies: companiesArr})
        }
      }
    }

    componentDidUpdate() {
      // reset('productForm');
    }

    componentWillReceiveProps(nextProps) {
      if (nextProps.dirty != this.props.dirty) {
        this.setState({
            dirty: nextProps.dirty
        });
      }
      if(nextProps.isActive && nextProps.isActive != this.props.isActive) {
        // console.log("is active", nextProps.isActive)
      }
  
      if((nextProps.isActive === true || nextProps.isActive === "true") && nextProps.isActive != this.props.isActive) {
        if(!this.props.paymentTerm_id && !nextProps.paymentTerm_id) {
          this.props.setDefaultOfForm('IsActive', false, 'vendorDetailForm');
          this.openConfirm();
        }
      }
      if((nextProps.overseas === true || nextProps.overseas === "true") && nextProps.overseas != this.props.overseas) {
        if(!this.props.paymentTerm_id && !nextProps.paymentTerm_id) {
          this.props.setDefaultOfForm('overseas', false, 'vendorDetailForm');
          this.openConfirm();
        }
      }
      if(nextProps.paymentTerm_id != this.props.paymentTerm_id) {
        if(!nextProps.paymentTerm_id || nextProps.paymentTerm_id.length === 0 ) {
          this.props.setDefaultOfForm('IsActive', false, 'vendorDetailForm');
          this.props.setDefaultOfForm('PaymentTerm_id', null, 'vendorDetailForm');
          this.openConfirm();
        }
      }

      if(isGGI && nextProps.selectedCompany && nextProps.selectedCompany.value && nextProps.selectedCompany.value != this.props.selectedCompany.value) {
        this.setState({currentCompanyId: nextProps.selectedCompany.value})
      }
      if(isGGI && nextProps.companies && nextProps.companies != null && nextProps.companies.length >0 && nextProps.companies != this.props.companies) {
        let companiesArr = [];
        nextProps.companies.map(item => {
          if(item.id != 3) {
            companiesArr.push({id: item.id, Name: item.Name, checked: false, level: 0})
          }
        })
        this.setState({companies: companiesArr})
      }
      if(isGGI && nextProps.currentVendorDetail && nextProps.currentVendorDetail && nextProps.currentVendorDetail.CompanyIDs && nextProps.currentVendorDetail.CompanyIDs.length > 0 && this.state.selectedCompanies.length == 0 && this.state.companies.length > 0) {
        this.initSelectVendor(nextProps.currentVendorDetail.CompanyIDs)
      }
      if (isVAK && nextProps.currentVendorDetail && nextProps.currentVendorDetail !== this.props.currentVendorDetail) {
        const { attachment_list } = nextProps.currentVendorDetail;
        this.setState({
          Files: attachment_list
        });
        attachment_list.map(item => {
          this.setState({
            [`Attachment${item.serial_num}`]: item.ImageURL,
            [`AttachmentName${item.serial_num}`]: item.file_name,
          })          
        })
      }
      if(isAP && nextProps.currentVendorDetail && nextProps.currentVendorDetail != this.props.currentVendorDetail) {
        
        if(!(nextProps.currentVendorDetail || {Level:''}).Level) {
          this.props.setDefaultOfForm('Level', '0', 'vendorDetailForm');
        }
        if((nextProps.currentVendorDetail || { Groups: []}).Groups.length) {
          this.setState({currentGroups: nextProps.currentVendorDetail.Groups});
        } else {
          this.setState({currentGroups: []});
        }
      }
    }

    initSelectVendor = (ids) => {
      let companies = []
      this.state.companies.map(item => {
        let checked = false;
        ids.map(id => {
          if(item.id == id) {
            checked = true;
          }
        })
        companies.push({...item, checked})
      })
      this.setState({companies})
    }

    routerWillLeave(nextLocation) {
      if (this.state.dirty) return 'Your work is not saved! Are you sure you want to leave?'
    }

    handleFormSubmit(formProps) {
      this.setState({ dirty: false });
      let selectCompanyIds = [];
      let formPro = {...formProps};
      if(isGGI && this.state.selectedCompanies.length > 0) {
        this.state.selectedCompanies.map(item => {
          selectCompanyIds.push(item.id)
        })
        formPro.companyids = selectCompanyIds;
      }
      if(isVAK){
        delete formPro.VendorNum
      }
      
      if (!this.props.currentVendor) {
        this.props.createVendor(formPro, this.state);
      }
      
      else {
        if(!this.checkPermission("change_vendor")) {
          this.props.editVendor(formPro, this.state);
        } else {
          alert("You have no permission!");
        }
      }
    }

    openConfirm() {
      this.setState({ confirmOpen: true });
    }

    closeConfirm() {
      this.setState({ confirmOpen: false });
    }
    closeCompany() {
      this.setState({ companyOpen: false });
    }
    openCompany() {
      this.setState({ companyOpen: true });
    }

    updateCompanySelect = (id, check) => {
      let stList = [...this.state.companies]
      if(id == 'all') {
        this.setState({checkedAll: check});
        stList.map((item) => {
          item.checked = check;
        })
      } else {
        stList.map((item) => {
          if(item.id == id) {
            item.checked = check;
          }
        })
      }
      let checkedList = [];
      stList.map((item)=>{
        if(item.checked) {
          checkedList.push(item);
        }
      })
      this.setState({
        selectedCompanies: checkedList,
        companies:stList,
      })
    }

    changeGroupsVisible = (groupsVisible = false) => {
      this.setState({
        groupsVisible,
      })
    }

    changeGroups = (currentGroups) => {
      this.setState({
        groupsVisible: false,
        currentGroups,
      })
    }

    breadcrumb() {
      if (!this.props.params.id) {
        return <Breadcrumb>
          <Breadcrumb.Item>
            <Translate value="general_management" />
          </Breadcrumb.Item>
          {/* <Breadcrumb.Item>
            <Translate value="vendors" />
          </Breadcrumb.Item> */}
          <Breadcrumb.Item active="true">
            <Translate value="create_vendor" />
          </Breadcrumb.Item>
        </Breadcrumb>
      }
      return <Breadcrumb>
        <Breadcrumb.Item>
          <Translate value="general_management" />
        </Breadcrumb.Item>
        {/* <Breadcrumb.Item>
          <Translate value="vendor" />
        </Breadcrumb.Item> */}
        <Breadcrumb.Item active="true">
          <Translate value="edit_vendor" />
        </Breadcrumb.Item>
      </Breadcrumb>
    }

    renderPaymentTerms() {
      if (this.props.paymentTermsIsLoading) return <Spinner/> // If payment term is loading, show a spinner.
      else {
        let paymentTermOptions = this.getPaymentTermOptions();
        return (
          <div>
            <Field name="PaymentTerm_id" component={Selection} options={paymentTermOptions}/>
          </div>
        )
      }
    }

    getPaymentTermOptions() {
      var paymentTermOptions = [];
      this.props.paymentTerms.map(paymentTerm => {
        paymentTermOptions.push({ value: paymentTerm.PaymentTerm_id, label: paymentTerm.Name })
      });
      return paymentTermOptions;
    }

    copyBillingToMailing(e) {
      e.preventDefault();
      if(this.props.billing) {
        this.props.setDefaultOfForm('Mailing', this.props.billing, 'vendorDetailForm')
      }
    }

    copyToBilling(e) {
      e.preventDefault();
      let billingInfo = {};
      if (this.props.Name) {
        billingInfo = { ...this.props.billing, AddressName: this.props.Name, Type: 'Billing' };
        this.props.setDefaultOfForm('Billing', billingInfo, 'vendorDetailForm');
      }
    }

    checkPermission(permission) {
        return false;
    }

    renderBillingCountry = () => {
      if (isGGI || isSV || isSKH) {
        return (
          <Col sm={ 3 }>
            <div className="form-group">
              <label><Translate value="country" /><span className="asteriksReq">*</span></label>
              <Field name="Billing.Country" component={ InputField } />
            </div>
          </Col>
        )
      }
      return null;
    }

    renderNote = () => {
      if(!isAP) return null
      return <Col sm={6}>
        <div className="form-group">
          <label><Translate value="note" /></label>
          <Field name="note2" component={ InputField } />
        </div>
      </Col>
    }

    renderLevel = () => {
      if(!isAP) return null
      return <Col sm={6}>
        <Field name="Level" title='level' component={LevelView} />
      </Col>
    }

    renderGroups = () => {
      if(!isAP) return null
      let groups = [];
      this.state.currentGroups.map(group => {
        group.Categories.map(category => {
          groups.push(`${group.Name || group.GroupName} - ${category.Name}`);
        })
      })
      return <Col sm={12}>
        <div 
        style={{display:'flex', width: '100%', flexDirection: 'row', alignItems: 'center'}}
        onClick={()=>{this.changeGroupsVisible(true)}}
        >
        <div style={{fontSize: '12px', fontWeight: '600'}}>
          <Translate value='business_type'/>:
        </div>
        <div 
        style={{
          width: '200px',
          marginLeft: '10px',
          borderWidth: '1px', 
          borderStyle: 'solid', 
          paddingBottom: '2px', 
          paddingTop: '2px', 
          paddingLeft: '4px', 
          paddingRight: '4px', 
          borderRadius: '4px', 
          backgroundColor:'white',
          whiteSpace: 'nowrap',
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          }}>
          {groups.toString()}
        </div>
        </div>
      </Col>
    }

    renderMoreVendorDetails = () => {
      if (isGGI) {
        return (
          <Row>
          <Col sm={4}>
            <div className="form-group">
              <label><Translate value="country" /><span className="asteriksReq">*</span></label>
              <Field name="country" component={ InputField } />
            </div>
          </Col>
          <Col sm={4}>
            <div className="form-group">
              <label><Translate value="website" /><span className="asteriksReq">*</span></label>
              <Field name="website" component={ InputField } />
            </div>
          </Col>
          <Col sm={4}>
            <div className="form-group">
              <label><Translate value="note" /><span className="asteriksReq">*</span></label>
              <Field name="note2" component={ InputField } />
            </div>
          </Col>
        </Row>
        )
      }
      return null;
    }

    renderMoreCompany = () => {
      if (isGGI && this.state.currentCompanyId && this.state.currentCompanyId == 3 ) {
        return (
          <SpinnerButton
            bsStyle="primary"
            icon="fa-pencil"
            onClick={this.openCompany}
            disabled={this.state.companyOpen}
            loading={this.state.companyOpen}
            translation={<Translate value="company" />}
          />
        )
      }
      return null;
    }

    renderMailingCountry = () => {
      if (isGGI || isSV || isSKH) {
        return (
          <Col sm={ 3 }>
            <div className="form-group">
              <label><Translate value="country" /><span className="asteriksReq">*</span></label>
              <Field name="Mailing.Country" component={ InputField } />
            </div>
          </Col>
        )
      }
      return null;
    }

    renderTitleOptions = () => {
      if (isGGI) {
        return (
          <Row className="form-horizontal">
            <div className="form-group">
            <label className="col-sm-2"><Translate value="title" /></label>
            <Col sm={ 10 }>
              <Field name={`Mailing.Title`} component={Selection} options={titleOptions} />
            </Col>
            </div>
          </Row>
        )
      }
      return null;
    }

    renderCountry = () => {
      if (isSKH) {
        // return <Row>
        //   <Col sm={ 4 }>
        //     <div className="form-group">
        //       <label><Translate value="country" /></label>
        //       <Field name="Country" component={ InputField } />
        //     </div>
        //   </Col>
        // </Row>
      }
    }
    onAttachmentDrop = (files, field, name) => {
      const formData = new FormData();
      formData.append('File', files[0]);
      const fileIndex = {
        "Attachment1": 1,
        "Attachment2": 2,
        "Attachment3": 3,
        "Attachment4": 4,
        "Attachment5": 5,
        "Attachment6": 6,
        "Attachment7": 7,
        "Attachment8": 8,
      }
      const success = (data) => {
        const imgData = this.state.Files || [];
        imgData.push({
          'serial_num': fileIndex[field], 
          'ImageURL': data.URL, 
          'file_name': data.fileName, 
          'file_size': data.size
        })
        this.setState({
          [field]: data.URL || data,
          [name]: data.fileName,
          Files: imgData
        })
      }
      getImageUrl(formData, success);
    }
    renderAttachmentDrop = (field, name) => {
      return (
        <Dropzone
          onDrop={(e) => {
            if (!this.state[field]) {
              this.onAttachmentDrop(e, field, name)
            }
          }}
          accept="image/*,.pdf"
          disableClick={this.state[field]}
        >
          <div style={{
            height: '100%',
            display: 'grid',
            placeItems: 'center',
          }}>
            {
              this.state[field] ? <div>
                <span
                  onClick={(e) => {
                    let Files = this.state.Files.filter(item => item.serial_num != field[field.length-1] )
                    e.stopPropagation();
                    this.setState({
                      [field]: '',
                      [name]: '',
                      Files
                    })
                  }}
                  style={{
                    position: 'absolute',
                    top: '0px',
                    right: '17px',
                    color: 'red',
                    fontSize: '17px',
                    fontWeight: 'bolder',
                    cursor: 'pointer'
                  }}>X</span>
                {
                  this.state[field].slice(-3) === 'pdf' ?
                  (
                    <a style={{ display: 'block', textAlign: 'center' }} href={this.state[field]} onClick={e => e.stopPropagation()}><Translate value="download_PDF" /></a>
                  ) : (
                    <div style={{ width: '100%', height: "80%" }}><a href={this.state[field]}><img src={this.state[field]} style={{ width: '100%', height: '180px', objectFit: 'fill' }}/></a></div>
                  )
                }
                <span style={{ display: 'block', width: '180px', whiteSpace: 'pre-wrap', overflowWrap: 'break-word', textAlign: 'center' }}>
                  {this.state[name]}
                </span>
              </div> : <span><Translate value="attachment" /></span>
            }
          </div>
        </Dropzone>
      )
    }
    renderAttach = () => {
      return <Panel id="attachment-panel" header={<h2><Translate value='vendor_attachments'/></h2> }>
      <Row>
        <Col xs={3}>
          {this.renderAttachmentDrop('Attachment1','AttachmentName1')}
        </Col>
        <Col xs={3}>
          {this.renderAttachmentDrop('Attachment2','AttachmentName2')}
        </Col>
        <Col xs={3}>
          {this.renderAttachmentDrop('Attachment3','AttachmentName3')}
        </Col>
        <Col xs={3}>
          {this.renderAttachmentDrop('Attachment4','AttachmentName4')}
        </Col>
      </Row>
      <Row style={{ marginTop: '5px' }}>
        <Col xs={3}>
          {this.renderAttachmentDrop('Attachment5','AttachmentName5')}
        </Col>
        <Col xs={3}>
          {this.renderAttachmentDrop('Attachment6','AttachmentName6')}
        </Col>
        <Col xs={3}>
          {this.renderAttachmentDrop('Attachment7','AttachmentName7')}
        </Col>
        <Col xs={3}>
          {this.renderAttachmentDrop('Attachment8','AttachmentName8')}
        </Col>
      </Row>
    </Panel>
    }
    render() {
        const vendorDetails = (<h2><Translate value="vendor_details" /></h2>)
        const billingDetails = (<h2><Translate value="billing_details" /></h2>);
        let mailingDetails = (<h2><Translate value="mailing_details" /></h2>);
        const shippingDetails = (<h2><Translate value="shipping_details" /></h2>);
        const activeVendor = (<Translate value="active_vendor" />);
        const overseas = (<Translate value="overseas" />);
        const confirmAction = (<Translate value="confirm_action" />);
        const companyAction = (<Translate value="company" />);
        const groupsTitle = (<Translate value="groups" />);
        const { handleSubmit, submitting, pristine } = this.props;
        let createDialogStyle = {
            height: '600px',
            marginTop: '-20%',
            width: '680px',
            marginLeft: '-10%',
            left: '45%',
        };
        if (isGGI) {
          mailingDetails = <h2><Translate value="contact_details" /></h2>
        }
        if (this.props.detailIsLoading && !this.props.detailError) return <ContentWrapper><br/>...reading data</ContentWrapper>
        else if (this.props.detailError) return <ContentWrapper><div className="alert alert-danger">{JSON.stringify(this.props.error)}</div></ContentWrapper>
        else {
            return (
              //---------------
              // Begin HTML
              //---------------
                <ContentWrapper>
                  <form method="get" action="#" onSubmit={handleSubmit(this.handleFormSubmit.bind(this)) } >
                    {/* Nav Trail */}
                    {this.breadcrumb() }
                    {/* Breadcrumb Buttons */}
                    <ButtonToolbar>
                      <Button
                        bsStyle="success"
                        type="submit"
                        action="submit"
                        onClick={handleSubmit(this.handleFormSubmit.bind(this))}
                      >
                        <em className="fa fa-save"/><Translate value="save" />
                      </Button>
                      <Button
                        bsStyle="danger"
                        type="reset"
                        href="/vendors">
                        <em className="fa fa-close"/><Translate value="cancel" />
                      </Button>
                    </ButtonToolbar> {/* End Breadcrumb Buttons */}

                    <Grid id="vendor-form">
                      {/* Row Wrapper */}
                      <Row>
                        {/* Vendor / Billing Column */}
                        <Col sm={ 8 }>
                          <Row>
                            {/* Vendor Details */}
                            <Col sm={ 12 }>
                              <Panel id={(isGGI || isSV) ? "vendor-details-380" : isDAICHEONG ? "vendor-details-260" : (isGFD || isAP) ? "vendor-details-300" : "vendor-details" } header={vendorDetails}>
                                <Row>
                                  <Col sm={ 8 }>
                                    {/* <h3><Translate value="general_information" /></h3> */}
                                  <div className="form-group">
                                    <label><Translate value="name" /><span className="asteriksReq">*</span></label>
                                    <Field name="Name" component={ InputField } />
                                  </div>
                                  <div className="form-group">
                                    <label><Translate value="description" /></label>
                                    <Field name="Description" component={ InputField } />
                                    </div>
                                  </Col>
                                  <Col sm={ 4 }>
                                    {/* <h3><Translate value="payment_information" /></h3> */}
                                     <div className="form-group">
                                       <label><Translate value="payment_term" /></label>
                                       { this.renderPaymentTerms() }
                                     </div>
                                     <div className="form-group">
                                       <label><Translate value="credit_status" /></label>
                                       <Field name="CreditStatus" component={ InputField } />
                                     </div>
                                  </Col>
                                  <Col sm={ 8 }>
                                    <Row>
                                      <Col sm={ 6 }>
                                        <div className="form-group">
                                          <label><Translate value="vendor_no" />{!isVAK && <span className="asteriksReq">*</span>}</label>
                                          <Field name="VendorNum" disabled={isVAK} component={ InputField } />
                                        </div>
                                      </Col>
                                      <Col sm={ 6 }>
                                        <div className="form-group">
                                          <label><Translate value={isOLG ? "item_no" : "ref_num"} /></label>
                                          <Field name="RefNum" component={ InputField } />
                                        </div>
                                      </Col>
                                    </Row>
                                  </Col>
                                  <Col sm={ 4 }>
                                    <Field name="IsActive" labelName={activeVendor} component={ IsActive } />
                                  </Col>
                                  {
                                    (isDAICHEONG) &&
                                    <Col sm={ 4 }>
                                      <Field name="overseas" labelName={overseas} component={ IsActive } />
                                    </Col>
                                  }
                                  
                                </Row>
                                {this.renderCountry()}
                                {/*
                                {
                                  isGFD &&
                                  <Row>
                                    <Col sm={4}>
                                      <label><Translate value="assoc_company" /></label>
                                      <Field name="AssociatedCompany" component={Selection} options={this.props.companySelection} />
                                    </Col>
                                  </Row>
                                }
                                */}
                                {
                                  isSV &&
                                  <Row>
                                    <Col sm={ 4 }>
                                      <div className="form-group">
                                        <label><Translate value="country" /></label>
                                        <Field name="Country" component={ InputField } />
                                      </div>
                                    </Col>
                                    <Col sm={ 4 }>
                                      <div className="form-group">
                                        <label><Translate value="business_type" /></label>
                                        <Field name="BusinessType" component={ InputField } />
                                      </div>
                                    </Col>
                                    <Col sm={ 4 }>
                                      <div className="form-group">
                                        <label><Translate value="credit_limit" /></label>
                                        <Field name="CreditLimit" component={ InputField } />
                                      </div>
                                    </Col>
                                  </Row>
                                }
                                {
                                  isSV &&
                                  <Row>
                                    <Col sm={ 4 }>
                                      <div className="form-group">
                                        <label><Translate value="account_num" /></label>
                                        <Field name="AccountNo" component={ InputField } />
                                      </div>
                                    </Col>
                                    <Col sm={ 4 }>
                                      <div className="form-group">
                                        <label><Translate value="debit_accnt" /></label>
                                        <Field name="DefaultDebitAcct" component={ InputField } />
                                      </div>
                                    </Col>
                                    <Col sm={ 4 }>
                                      <div className="form-group">
                                        <label><Translate value="credit_accnt" /></label>
                                        <Field name="DefaultCreditAcct" component={ InputField } />
                                      </div>
                                    </Col>
                                  </Row>

                                }
                                {
                                  isSV &&
                                  <Row>
                                    <Col sm={ 4 }>
                                      <div className="form-group">
                                        <label><Translate value="notation" /></label>
                                        <Field name="Note" component={ InputField } />
                                      </div>
                                    </Col>
                                    <Col sm={ 4 }>
                                      <div className="form-group">
                                        <label><Translate value="note" /></label>
                                        <Field name="Note2" component={ InputField } />
                                      </div>
                                    </Col>
                                    <Col sm={ 4 }>
                                      <div className="form-group">
                                        <label><Translate value="website" /></label>
                                        <Field name="Website" component={ InputField } />
                                      </div>
                                    </Col>
                                  </Row>
                                }
                                {this.renderNote()}
                                {this.renderLevel()}
                                {this.renderGroups()}
                                {this.renderMoreVendorDetails()}
                                {this.renderMoreCompany()}
                              </Panel>
                            </Col> {/* End Vendor Details */}

                            {/* Billing Details */}
                            <Col sm={ 6 }>
                              <Panel id="billing-details" header={billingDetails}>
                                {/* <h3><Translate value="billing_address" /></h3> */}
                                {!isSV &&
                                  <Row className="form-horizontal">
                                    <div className="form-group">
                                      <label className="col-sm-2"><Translate value="name" /></label>
                                      <div className="col-sm-10">
                                        <Field name="Billing.AddressName" component={ InputField } />
                                      </div>
                                    </div>
                                  </Row>
                                }
                                {
                                  isSV &&
                                  <Row className="form-horizontal">
                                  <div className="form-group">
                                    <label className="col-sm-2"><Translate value="name" /></label>
                                    <div className="col-sm-7">
                                      <Field name="Billing.AddressName" component={ InputField } />
                                    </div>
                                    <div className='col-sm-3'>
                                      <Button
                                        bsStyle="default"
                                        className="auto-fill"
                                        type="button"
                                        onClick={this.copyToBilling.bind(this)}
                                      >
                                        <em className="fa fa-edit" /><Translate value="fill" />
                                      </Button>
                                    </div>
                                  </div>
                                </Row>
                              }
                              <Row className="form-horizontal">
                                <div className="form-group">
                                  <label className="col-sm-2"><Translate value="street" /><span className="asteriksReq">*</span></label>
                                  <div className="col-sm-10">
                                    <Field name="Billing.Street" component={ InputField } />
                                  </div>
                                </div>
                              </Row>
                              {
                                isSV &&
                                <Row className="form-horizontal">
                                  <div className="form-group">
                                    <label className="col-sm-2"><Translate value="street_2" /></label>
                                    <div className="col-sm-10">
                                      <Field name="Billing.Street1" component={ InputField } />
                                    </div>
                                  </div>
                                </Row>
                              }
                                <Row>
                                  <Col sm={ (isGGI || isSV)  ? 3 : 6 }>
                                    <div className="form-group">
                                      <label><Translate value="city" /><span className="asteriksReq">*</span></label>
                                      <Field name="Billing.City" component={ InputField } />
                                    </div>
                                  </Col>
                                  <Col sm={ 3 }>
                                    <div className="form-group">
                                      <label><Translate value="state" />{!isSKH && <span className="asteriksReq">*</span>}</label>
                                      <Field name="Billing.State" component={ InputField } />
                                    </div>
                                  </Col>
                                  <Col sm={ 3 }>
                                    <div className="form-group">
                                      <label><Translate value="zip" />{!isSKH && <span className="asteriksReq">*</span>}</label>
                                      <Field name="Billing.Zip" component={ InputField } />
                                    </div>
                                  </Col>
                                  {this.renderBillingCountry()}
                                </Row>

                                {/* <h3><Translate value="billing_contact" /></h3> */}
                                <Row>
                                  <Col sm={4}>
                                    <div className="form-group">
                                      <label><Translate value="first_name" /></label>
                                      <Field name="Billing.FirstName" component={ InputField } />
                                    </div>
                                  </Col>
                                  <Col sm={4}>
                                    <div className="form-group">
                                      <label><Translate value="last_name" /></label>
                                      <Field name="Billing.LastName" component={ InputField } />
                                    </div>
                                  </Col>
                                  <Col sm={4}>
                                      <div className="form-group">
                                        <label><Translate value="tel1" /></label>
                                        <Field name="Billing.Telephone" component={ InputField } />
                                      </div>
                                    </Col>
                                </Row>

                                <Row>
                                  <Col sm={ 4 }>
                                    <div className="form-group">
                                      <label><Translate value="tel2" /></label>
                                      <Field name="Billing.Telephone2" component={ InputField } />
                                    </div>
                                  </Col>
                                  <Col sm={ 4 }>
                                    <div className="form-group">
                                      <label><Translate value="cel" /></label>
                                      <Field name="Billing.Cellphone" component={ InputField } />
                                    </div>
                                  </Col>
                                  <Col sm={ 4 }>
                                    <div className="form-group">
                                      <label><Translate value="fax" /></label>
                                      <Field name="Billing.Fax" component={ InputField } />
                                    </div>
                                  </Col>
                                </Row>
                                <Row>
                                  <Col sm={12}>
                                    <div className="form-group">
                                      <label><Translate value="email" /></label>
                                      <span className="asteriksReq"><Translate value="press_enter_for_emails" /></span>
                                        <Field
                                          name="Billing.Email"
                                          component="Textarea"
                                          className="form-control resize-vertical"
                                          style={{ minHeight: '40px' }}
                                          resize="vertical"
                                        />
                                    </div>
                                  </Col> 
                                </Row>
                              </Panel>
                            </Col> {/* End Billing Details */}

                            {/* Mailing Details */}
                            <Col sm={ 6 }>
                              <Panel id="mailing-details" header={mailingDetails}>
                                {/* <h3><Translate value="mailing_address" /></h3> */}
                                <Row className="form-horizontal">
                                  <div className="form-group">
                                    <label className="col-sm-2"><Translate value="name" /></label>
                                    <Col sm={ 6 }>
                                      <Field name="Mailing.AddressName" component={ InputField } />
                                    </Col>
                                    <Col sm={ 4 }>
                                      <Button
                                      bsStyle="default"
                                      className="auto-fill"
                                      type="button"
                                      onClick={this.copyBillingToMailing.bind(this)} >
                                        <em className="fa fa-edit"/><Translate value="auto_fill" />
                                      </Button>
                                    </Col>
                                  </div>
                                </Row>
                                {this.renderTitleOptions()}
                                <Row className="form-horizontal">
                                    <div className="form-group">
                                      <label className="col-sm-2"><Translate value="street" /><span className="asteriksReq">*</span></label>
                                      <Col sm={ 10 }>
                                        <Field name="Mailing.Street" component={ InputField } />
                                      </Col>
                                    </div>
                                </Row>
                                {isSV &&
                                   <Row className="form-horizontal">
                                   <div className="form-group">
                                     <label className="col-sm-2"><Translate value="street_2" /></label>
                                     <Col sm={ 10 }>
                                       <Field name="Mailing.Street1" component={ InputField } />
                                     </Col>
                                   </div>
                               </Row>
                                }
                                <Row>
                                  <Col sm={ (isGGI || isSV) ? 3 : 6 }>
                                    <div className="form-group">
                                      <label><Translate value="city" /><span className="asteriksReq">*</span></label>
                                      <Field name="Mailing.City" component={ InputField } />
                                    </div>
                                  </Col>
                                  <Col sm={ 3 }>
                                    <div className="form-group">
                                      <label><Translate value="state" />{!isSKH && <span className="asteriksReq">*</span>}</label>
                                      <Field name="Mailing.State" component={ InputField } />
                                    </div>
                                  </Col>
                                  <Col sm={ 3 }>
                                    <div className="form-group">
                                      <label><Translate value="zip" />{!isSKH && <span className="asteriksReq">*</span>}</label>
                                      <Field name="Mailing.Zip" component={ InputField } />
                                    </div>
                                  </Col>
                                {this.renderMailingCountry()}
                                </Row>
                                {/* <h3><Translate value="mailing_contact" /></h3> */}
                                  <Row>
                                    <Col sm={ 4 }>
                                      <div className="form-group">
                                        <label><Translate value="first_name" /></label>
                                        <Field name="Mailing.FirstName" component={ InputField } />
                                      </div>
                                    </Col>
                                    <Col sm={ 4 }>
                                      <div className="form-group">
                                        <label><Translate value="last_name" /></label>
                                        <Field name="Mailing.LastName" component={ InputField } />
                                      </div>
                                    </Col>
                                    <Col sm={ 4 }>
                                      <div className="form-group">
                                        <label><Translate value="tel" /></label>
                                        <Field name="Mailing.Telephone" component={ InputField } />
                                      </div>
                                    </Col>
                                  </Row>
                                  <Row>
                                    {/* <Col sm={ 8 }>
                                      <div className="form-group">
                                        <label><Translate value="email" /></label>
                                        <Field name="Mailing.Email" component={ InputField } />
                                      </div>
                                    </Col> */}
                                     <Col sm={ 4 }>
                                    <div className="form-group">
                                      <label><Translate value="tel2" /></label>
                                      <Field name="Mailing.Telephone2" component={ InputField } />
                                    </div>
                                  </Col>
                                    <Col sm={ 4 }>
                                      <div className="form-group">
                                        <label><Translate value="cel" /></label>
                                        <Field name="Mailing.Cellphone" component={ InputField } />
                                      </div>
                                    </Col>
                                    <Col sm={ 4 }>
                                      <div className="form-group">
                                        <label><Translate value="fax" /></label>
                                        <Field name="Mailing.Fax" component={ InputField } />
                                      </div>
                                    </Col>
                                  </Row>
                                  <Row>
                                  <Col sm={12}>
                                    <div className="form-group">
                                      <label><Translate value="email" /></label>
                                      <span className="asteriksReq"><Translate value="press_enter_for_emails" /></span>
                                        <Field
                                          name="Mailing.Email"
                                          component="Textarea"
                                          className="form-control resize-vertical"
                                          style={{ minHeight: '40px' }}
                                          resize="vertical"
                                        />
                                    </div>
                                  </Col> 
                                </Row>
                              </Panel>
                            </Col> {/* End Mailing Details */}
                          </Row>
                        </Col> {/* End Vendor / Billing Column */}

                        {/* Shipping Information */}
                        <Col sm={ 4 }>
                          <Panel id="shipping-details" header={shippingDetails}>
                            <h3><Translate value="shipping_info" /></h3>
                            <FieldArray
                              name="Shipping"
                              component={renderShipping}
                              shipping={this.props.shipping}
                              billing={this.props.billing}
                              // currentShipping={ this.props.currentVendorDetail ? this.props.currentVendorDetail.Shipping:[]}
                              changeFieldArrayOfForm={this.props.changeFieldArrayOfForm}
                            />
                            {/* <h3><Translate value="contact" /></h3>
                            <FieldArray name="Shipping" component={renderShippings}
                              shipping={this.props.billing}
                              currentShipping={ this.props.currentVendorDetail ? this.props.currentVendorDetail.Shipping:[]}
                              saveCurrentBilling={() => {this.saveCurrentBilling()}}
                              setCurrentShipping={(newShipping) => {this.setCurrentShipping(newShipping)}}
                              /> */}
                          </Panel>
                        </Col> {/* End Shipping Information */}
                      </Row> {/* End Row Wrapper */}
                      { isVAK && <Row>
                        <Col sm={8}>
                          {this.renderAttach()}
                        </Col>
                      </Row> }
                      { this.props.isCreating || this.props.isEditing && <Spinner/> }
                      {/* this.props.createError && <div className="alert alert-danger marginTopStyle" >{JSON.stringify(this.props.createError)}</div> */}
                      {/* this.props.editError && <div className="alert alert-danger marginTopStyle" >{JSON.stringify(this.props.editError)}</div> */}

                      {/* <SkyLightStateless isVisible={this.state.paymentTermOpen} onCloseClicked={() => { this.closePaymentTerm() } } title={addANewPaymentTerm}>
                        <PaymentTermForm closePT={this.closePaymentTerm} />
                      </SkyLightStateless> */}
                    </Grid>
                    <SkyLightStateless dialogStyles={createDialogStyle} isVisible={this.state.confirmOpen} onCloseClicked={() => { this.closeConfirm() }} title={confirmAction}>
                        <ConfirmActionModal case={this.state.case} closeC={this.closeConfirm} />
                    </SkyLightStateless>
                    <SkyLightStateless
                    dialogStyles={createDialogStyle}
                    isVisible={this.state.companyOpen}
                    onCloseClicked={() => { this.closeCompany(); }}
                    title={companyAction}
                    >
                      <MarketingModal
                      close={this.closeCompany}
                      all={this.state.companies}
                      enableSelect={true}
                      canSelectAll
                      checkedAll={this.state.checkedAll}
                      update={this.updateCompanySelect}
                      />
                    </SkyLightStateless>
                    <SkyLightStateless
                    dialogStyles={createDialogStyle}
                    isVisible={this.state.groupsVisible}
                    onCloseClicked={() => { this.changeGroupsVisible(); }}
                    title={groupsTitle}
                    >
                      <GroupsModal
                      close={this.changeGroupsVisible}
                      data={this.state.currentGroups}
                      confirm={this.changeGroups}
                      />
                    </SkyLightStateless>
                  </form>
                </ContentWrapper>
                //---------------
                // End HTML
                //---------------
            )
        }
    }
}

export default withRouter(VendorDetailForm);



// WEBPACK FOOTER //
// ./master/jsx/components/Vendors/vendorDetailForm.jsx